var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgYoutube = function SvgYoutube(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 15,
    viewBox: "0 0 22 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2192 1.12491C20.5497 1.46563 20.7844 1.88753 20.8997 2.348C21.2074 4.05436 21.3569 5.78553 21.346 7.51941C21.3521 9.22736 21.2027 10.9323 20.8997 12.6132C20.7844 13.0737 20.5497 13.4956 20.2192 13.8363C19.8887 14.177 19.4741 14.4245 19.0174 14.5537C17.3486 15 10.6733 15 10.6733 15C10.6733 15 3.99797 15 2.32915 14.5537C1.88169 14.4313 1.47337 14.1955 1.14364 13.8692C0.813918 13.5428 0.573931 13.137 0.446868 12.6908C0.139074 10.9844 -0.0103322 9.25328 0.000554636 7.51941C-0.00794867 5.79849 0.141448 4.08042 0.446868 2.3868C0.562122 1.92634 0.796851 1.50444 1.12735 1.16372C1.45784 0.823002 1.8724 0.575535 2.32915 0.446313C3.99797 0 10.6733 0 10.6733 0C10.6733 0 17.3486 0 19.0174 0.407503C19.4741 0.536725 19.8887 0.784192 20.2192 1.12491ZM14.0699 7.51857L8.49102 10.6913V4.34587L14.0699 7.51857Z",
    fill: "currentColor"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgYoutube, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/youtube.17809577.svg";
export { ForwardRef as ReactComponent };